import type { Schema } from "@/shared/components/Form/types";
import { TagsAutocompleteQuery } from "@/partner/entities/tags";
import React from "react";
import type { TFunction } from "i18next";
import { ShareUrl } from "@/shared/components/ShareUrl";

export const getPostFormSchema = (t: TFunction): Schema => ({
  _main: {
    type: "block",
    subschema: {
      title: {
        type: "text",
        label: t("posts.form.titleLabel"),
        required: true,
        xs: 12,
        fullWidth: true,
      },
      slug: {
        type: "text",
        label: "URL-slug",
        xs: 12,
        fullWidth: true,
      },
      description: {
        type: "text",
        label: t("posts.form.descriptionLabel"),
        multiline: true,
        rows: 3,
        xs: 12,
        fullWidth: true,
      },
      tagIds: {
        type: "autocomplete",
        label: t("posts.form.tagsLabel"),
        multiple: true,
        xs: 12,
        fullWidth: true,
        query: TagsAutocompleteQuery,
      },
      text: {
        type: "markdown",
        label: t("posts.form.textLabel"),
        rows: 10,
        xs: 12,
        fullWidth: true,
      },
    },
    hideHeader: true,
    xs: 12,
    md: 8,
  },
  _right: {
    type: "block",
    subschema: {
      imageId: {
        type: "banner",
        orientation: "horizontal",
        required: true,
        xs: 12,
        fullWidth: true,
      },
      _shareUrl: {
        type: "fieldComponent",
        xs: 12,
        component: ({ metadata }) =>
          React.createElement(ShareUrl, {
            url: metadata?.url,
          }),
      },
      accessOnlyViaLink: {
        type: "switch",
        label: t("posts.form.accessOnlyViaLinkLabel"),
        xs: 12,
        fullWidth: true,
      },
    },
    hideHeader: true,
    xs: 12,
    md: 4,
  },
});
